import GenericNotificationTag from './GenericNotificationTag';

export default GenericNotificationTag;
